import { EventEmitter, Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MobileDetectorService {

    public breakpooint: number = 960;
    public breakpointCheck: EventEmitter<any> = new EventEmitter<any>();

    private watchScreenSizeChange = false;
    private lastScreenWidth = window.innerWidth;

    constructor() { }

    public isMobile(): boolean {
        return window.innerWidth < this.breakpooint;
    }

    private handleWindowWidthChange() {
        if (this.watchScreenSizeChange) {
            const innerWidth = window.innerWidth;

            if (this.lastScreenWidth <= this.breakpooint && innerWidth >= this.breakpooint) {
                this.breakpointCheck.emit({
                    mobile: false
                });
            } else if (this.lastScreenWidth >= this.breakpooint && innerWidth < this.breakpooint) {
                this.breakpointCheck.emit({
                    mobile: true
                });
            }
            this.lastScreenWidth = innerWidth;
        }
    }

    public initScreenSizeWatcher() {
        if (!this.watchScreenSizeChange) {
            this.watchScreenSizeChange = true;

            fromEvent(window, 'resize').pipe(
                debounceTime(200)
            ).subscribe((event) => {
                this.handleWindowWidthChange();
            });
        }
    }
}
